// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"dee399a4","408":"1c118f38","423":"1c118f38"}[chunkId] + ".chunk.css";
};